import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { MODALS } from 'src/models/ModalModel';
import { openModal } from 'src/redux/actions/modalActions';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { t } from 'src/lib/language';
import { setSelections } from 'src/redux/actions/selectionActions';
import { ENTITIES } from 'src/models/QuerybuilderModel';

interface Props {
  invoiceId?: string | number;
}

const ShowInvoiceTransactionButton = (props: ButtonProps & Props) => {
  const dispatch = useAppDispatch();
  const { disabled } = props;
  const lang = useSelector((state: Store) => state.language.language);
  const { invoiceId } = props;

  const handleOpen = () => {
    if (invoiceId) {
      dispatch(setSelections({
        entity: ENTITIES.invoices,
        selections: [invoiceId],
      }));
    }
    dispatch(openModal({ modal: MODALS.editInvoice }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.show_transaction_invoice')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.action}
            onClick={handleOpen}
            disabled={disabled}>
            <DescriptionOutlinedIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default ShowInvoiceTransactionButton;
